/* Mejoras mentoría: tallas en botones + selector de packs (1/2/3 piezas) en ficha de producto */
(function () {
  var TIERS = [
    { n: 1, label: '1 pezzo', sub: 'Prezzo promozionale standard', off: 0 },
    { n: 2, label: '2 pezzi – più scelto', sub: '10% di sconto aggiuntivo!', off: 10, badge: 'La più scelta' },
    { n: 3, label: '3 pezzi – miglior offerta', sub: '15% di sconto aggiuntivo!', off: 15 }
  ];
  var state = { n: 1, pieces: [] };
  var product = null;
  var fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

  function comp() { return document.querySelector('mf-product-information'); }
  function form() { var c = comp(); return c && c.querySelector('form.mf-form'); }
  function currentVariantId() { var f = form(); var i = f && f.querySelector('input[name="id"],input[name="id_off"]'); return i ? Number(i.value) : null; }
  function variantById(id) { return product && product.variants.find(function (v) { return v.id === id; }); }

  function loadProduct() {
    if (product || !/\/products\//.test(location.pathname)) return Promise.resolve(product);
    var handle = location.pathname.split('/products/')[1].split('/')[0];
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { product = p; return p; });
  }

  /* ---------- Tallas: desactivado (pedido Igor 2026-09-28) ----------
     Igor quiere un <select> nativo, simple, para las tallas — no botones.
     Se deja la funcion vacia (en vez de borrar sizeButtons()/sus llamadas)
     para no tocar mas puntos de este archivo; el <select class="mf-select">
     ya tiene su propio estilo bonito en sections/product-information.liquid
     y ahora se queda visible tal cual, sin que nada le anada
     .mf-select--hidden ni cree los botones .mf-size-btn. */
  function sizeButtons() {
    return;
  }

  /* ---------- Packs ---------- */
  function optionSelects(idx, variant) {
    var html = '';
    product.options.forEach(function (opt, oi) {
      var cur = variant ? variant.options[oi] : opt.values[0];
      html += '<select class="mf-pack-opt" data-piece="' + idx + '" data-oi="' + oi + '" aria-label="' + opt.name + '">' +
        opt.values.map(function (v) { return '<option' + (v === cur ? ' selected' : '') + '>' + v + '</option>'; }).join('') + '</select>';
    });
    return html;
  }

  function prices(n, off) {
    var v = variantById(currentVariantId()) || (product && product.variants[0]);
    if (!v) return null;
    var base = v.price * n, compare = Math.max(v.compare_at_price || 0, v.price) * n;
    var now = off > 0 ? Math.floor(base * (100 - off) / 100 / 100) : base / 100;
    var was = compare / 100;
    var pct = was > now ? Math.round((was - now) / was * 100) : 0;
    return { now: now, was: was, pct: pct };
  }

  function isCompleto() { return !!product && /\bcomplet[oi]\b/i.test(product.title || ''); }
  function tierLabel(t) {
    if (!isCompleto()) return t.label;
    return { 1: '1 completo', 2: '2 completi – più scelto', 3: '3 completi – miglior offerta' }[t.n] || t.label;
  }

  function renderPack() {
    // Pedido Igor 2026-10-03: packs "Sconto aggiuntivo per pacchetto oggi" (1/2/3 pezzi)
    // ocultos en toda la tienda, en escritorio y móvil. Reversible: para volver a mostrarlos,
    // borra esta línea y la de abajo (return).
    return;
    var c = comp(); if (!c || !product || product.variants.length < 1) return;
    var add = c.querySelector('[data-add]'); if (!add) return;
    var box = c.querySelector('.mf-pack');
    if (!box) {
      box = document.createElement('div');
      box.className = 'mf-pack';
      var anchor = add.closest('.mf-buy, .mf-actions, .mf-buttons') || add;
      anchor.insertAdjacentElement('afterend', box); // pedido Igor 2026-09-28: debajo del boton anadir al carrito, no encima
    }
    var v1 = variantById(currentVariantId());
    var html = '<div class="mf-pack__title"><span>Sconto aggiuntivo per pacchetto oggi</span></div>';
    TIERS.forEach(function (t) {
      var p = prices(t.n, t.off);
      var active = state.n === t.n;
      html += '<label class="mf-pack__opt' + (active ? ' is-active' : '') + '">' +
        (t.badge ? '<span class="mf-pack__badge">' + t.badge + '</span>' : '') +
        '<input type="radio" name="mf-pack" value="' + t.n + '"' + (active ? ' checked' : '') + '>' +
        '<span class="mf-pack__txt"><strong>' + tierLabel(t) + '</strong><small>' + t.sub + '</small></span>' +
        (p ? '<span class="mf-pack__price"><strong>' + fmt.format(p.now) + '</strong>' + (p.was > p.now ? '<s>' + fmt.format(p.was) + '</s><span class="mf-pack__save">-' + p.pct + '%</span>' : '') + '</span>' : '');
      if (active && t.n > 1 && product.variants.length > 1) {
        html += '<span class="mf-pack__pieces"><small>' + product.options.map(function (o) { return o.name; }).join(', ') + '</small>';
        for (var i = 0; i < t.n; i++) {
          var pv = state.pieces[i] || (i === 0 ? v1 : v1);
          html += '<span class="mf-pack__row"><em>#' + (i + 1) + '</em>' + optionSelects(i, i === 0 ? v1 : pv) + '</span>';
        }
        html += '<span class="mf-pack__add-row"><button type="button" class="mf-button mf-button--primary mf-pack__add" data-pack-add>Aggiungi</button></span>';
        html += '</span>';
      }
      html += '</label>';
    });
    box.innerHTML = html;
  }

  function readPieces() {
    var out = [];
    for (var i = 0; i < state.n; i++) {
      var sels = document.querySelectorAll('.mf-pack-opt[data-piece="' + i + '"]');
      if (!sels.length) { out.push(variantById(currentVariantId())); continue; }
      var vals = Array.prototype.map.call(sels, function (s) { return s.value; });
      out.push(product.variants.find(function (v) { return v.options.join('|') === vals.join('|'); }) || null);
    }
    return out;
  }

  document.addEventListener('change', function (e) {
    if (e.target.name === 'mf-pack') { state.n = Number(e.target.value); state.pieces = []; renderPack(); syncQty(); return; }
    if (e.target.classList.contains('mf-pack-opt')) {
      var i = Number(e.target.dataset.piece);
      state.pieces = readPieces();
      if (i === 0) {
        var v = state.pieces[0];
        if (v) syncMainSelection(v);
      }
    }
  });

  function syncMainSelection(v) {
    var c = comp(); if (!c) return;
    product.options.forEach(function (opt, oi) {
      var val = v.options[oi];
      var fs = c.querySelectorAll('[data-option-position]')[oi]; if (!fs) return;
      var input = Array.prototype.find.call(fs.querySelectorAll('input[data-option-value-id]'), function (x) {
        if (!x.value) return false;
        if (x.dataset.value === val || x.getAttribute('aria-label') === val) return true;
        /* Markup real: <input id="MFOption-...-N"> + <label for="MFOption-...-N">Testo</label>
           hermanos (no input.closest('label')) — pedido Igor 2026-10-02: buscar por label[for]. */
        var lbl = x.closest('label') || (x.id && document.querySelector('label[for="' + x.id + '"]'));
        return !!(lbl && lbl.textContent.trim() === val);
      });
      if (input && !input.checked) { input.click(); return; }
      var sel = fs.querySelector('select[data-option-value-id]');
      if (sel) { var o = Array.prototype.find.call(sel.options, function (x) { return x.textContent.trim() === val; }); if (o && sel.value !== o.value) { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); } }
    });
  }

  function syncQty() {
    var f = form(); if (!f) return;
    var q = f.querySelector('input[name="quantity"]');
    if (q) q.value = 1;
  }

  var bypass = false;
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('mf-product-information [data-add]');
    if (!add || bypass || state.n < 2 || add.dataset.waiting === 'true' || add.dataset.purchasable !== 'true') return;
    var pieces = readPieces();
    if (pieces.some(function (p) { return !p || !p.available; })) { e.preventDefault(); e.stopImmediatePropagation(); alert('Seleziona una combinazione disponibile per ogni pezzo.'); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    var extra = pieces.slice(1).reduce(function (acc, p) { acc[p.id] = (acc[p.id] || 0) + 1; return acc; }, {});
    var items = Object.keys(extra).map(function (id) { return { id: Number(id), quantity: extra[id] }; });
    add.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () { bypass = true; add.disabled = false; add.click(); bypass = false; })
      .catch(function () { add.disabled = false; });
  }, true);

  /* Boton "Aggiungi" dentro de la caja expandida de piezas (pedido Igor
     2026-10-02): debe funcionar EXACTAMENTE igual que el boton real de
     anadir al carrito, asi que simplemente reenvia el click a ese boton
     real ([data-add]) en vez de duplicar logica. El listener de arriba
     (capturing, en document) sigue siendo el que intercepta ese click
     real y hace el fetch a /cart/add.js para las piezas extra cuando
     state.n >= 2, exactamente igual que si el usuario pulsara el boton
     original.
     Ajuste 2026-10-02: no debe hacer falta elegir una talla en el
     selector principal (fuera de la caja) para que funcione — se
     sincroniza el selector principal con la pieza #1 justo antes de
     pulsar el boton real, y se espera (varios frames) a que el tema
     marque el boton real como listo (no disabled) antes de clicarlo. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pack-add]');
    if (!btn) return;
    e.preventDefault();
    var pieces = readPieces();
    var v1 = pieces[0] || variantById(currentVariantId());
    if (v1) syncMainSelection(v1);
    var tries = 0;
    (function tryClick() {
      var realAdd = document.querySelector('mf-product-information [data-add]');
      if (!realAdd) return;
      if ((!realAdd.disabled && realAdd.dataset.purchasable === 'true') || tries >= 30) { realAdd.click(); return; }
      tries++;
      requestAnimationFrame(tryClick);
    })();
  });

  /* ---------- Chip "Risparmi €X" (pedido Igor 2026-10-07) ----------
     Importe = compare_at_price - price de la variante seleccionada, formato italiano (€50,05). Solo si compare_at > price.
     El texto lo pinta la seccion (product-information) con -X%; aqui se sustituye. Al cambiar de variante la seccion se vuelve a
     renderizar y el MutationObserver de abajo lo repinta. Si no hay datos, se deja la etiqueta original visible (data-risp="x"). */
  function fmtEUR(cents) {
    var p = (Math.abs(cents) / 100).toFixed(2).split('.');
    return '€' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }
  function renderChip() {
    var c = comp(); if (!c) return;
    var b = c.querySelector('.mf-price [data-discount-badge]'); if (!b) return;
    if (!product) { loadProduct().then(function (p) { if (p) renderChip(); else b.setAttribute('data-risp', 'x'); }).catch(function () { b.setAttribute('data-risp', 'x'); }); return; }
    var v = variantById(currentVariantId()) || product.variants[0];
    if (!v) { b.setAttribute('data-risp', 'x'); return; }
    var saving = (v.compare_at_price || 0) - v.price;
    if (!(saving > 0)) { b.hidden = true; b.setAttribute('data-risp', '0'); return; }
    b.hidden = false;
    var key = String(saving);
    if (b.getAttribute('data-risp') === key) return;
    b.innerHTML = '<span class="mf-chip-lbl">Risparmi</span> <span class="mf-chip-imp">' + fmtEUR(saving) + '</span>';
    b.setAttribute('data-risp', key);
  }

  function run() { sizeButtons(); renderChip(); loadProduct().then(function () { if (!document.querySelector('.mf-pack')) renderPack(); }); }
  var mo = new MutationObserver(function () { clearTimeout(run._t); run._t = setTimeout(function () { sizeButtons(); renderChip(); if (product && !document.querySelector('.mf-pack')) renderPack(); else if (product) renderPrices(); }, 60); });
  function renderPrices() { var box = document.querySelector('.mf-pack'); if (!box) return; var id = currentVariantId(); if (box.dataset.v !== String(id)) { box.dataset.v = String(id); renderPack(); document.querySelector('.mf-pack').dataset.v = String(id); } }
  function init() { var c = comp(); if (!c) return; run(); mo.observe(c, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
